import React from 'react';
import { Message } from './types';

interface ChatMessageProps {
  message: Message;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isBot = message.type === 'bot';

  return (
    <div className={`flex ${isBot ? 'justify-start' : 'justify-end'}`}>
      <div
        className={`max-w-[80%] rounded-lg p-3 ${
          isBot
            ? 'bg-gray-100 text-gray-800'
            : 'bg-blue-600 text-white'
        }`}
      >
        {isBot && (
          <div className="font-semibold text-sm text-gray-600 mb-1">
            {message.name}
          </div>
        )}
        <p className="text-sm">{message.content}</p>
      </div>
    </div>
  );
};

export default ChatMessage;